// extracted by mini-css-extract-plugin
export default {"uploader":"lEMc9"};